import "./App.css";
import NavBar from "./components/NavBar";

//import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/pages/HomePage/Home";
import Footer from "./components/pages/Footer/Footer";
import Music from "./components/pages/Music/Music";
import Bookings from "./components/pages/Bookings/Bookings";
import Privacy from "./components/pages/Privacy/Privacy";
import CookieBanner from "./components/CookieBanner/CookieBanner";

function App() {
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" exact Component={Home} />
        <Route path="/music" exact Component={Music} />
        <Route path="/bookings" exact Component={Bookings} />
        <Route path="/privacy" exact Component={Privacy} />
      </Routes>
      <Footer />
      <CookieBanner />
    </Router>
  );
}

export default App;
